'use client';
import { Provider } from 'react-redux';
import { store } from './index';

export function StoreProvider({ children }: { children: React.ReactNode }) {
    return <Provider data-component-id="src/store/provider.tsx:6:11" data-component-path="src/store/provider.tsx" data-component-line="6" data-component-end-line="6" data-component-file="provider.tsx" data-component-name="Provider" data-component-content="%7B%22elementName%22%3A%22Provider%22%7D" store={store}>{children}</Provider>;
}
